
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'

/**
 * 単元別問題選択 選択肢レイアウト
 */
@Component({
  components: {
    ButtonOptional,
  },
})
export default class ProblemPassageContent extends Vue {
  /** 線の有無 */
  @Prop()
  private showLine!: boolean

  /** 履歴を表示するか否か */
  @Prop()
  private showHistoryButton!: boolean

  /** 線を破線にするか否か */
  @Prop({ default: false })
  private lineStyleDashed!: boolean

  /** 履歴ボタン押下時のイベント */
  @Prop()
  private eventClickHistoryButton!: () => void

  /** 問題クリック時のイベント */
  @Prop()
  private eventClickProblem!: () => Promise<void>
}
